package pl.nickers.match3

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material3.Button
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import pl.nickers.match3.ui.GemChip

@Composable
fun StartScreen(
    hasContinueGame: Boolean,
    livesInfo: LivesInfo,
    /** Gem balance for the corner chip (E18/F18.4). Supplied by the caller; never computed here. */
    gemBalance: Int,
    onNewGame: () -> Unit,
    onContinue: () -> Unit,
    onJourney: () -> Unit,
    onTestLevels: () -> Unit,
    onProfile: () -> Unit,
    onFamiliars: () -> Unit,
    onSettings: () -> Unit,
    audioPlayer: AudioPlayer = remember { AudioPlayer() },
) {
    Box(modifier = Modifier.fillMaxSize()) {
        IconButton(
            onClick = onSettings,
            modifier = Modifier.align(Alignment.TopEnd).padding(16.dp),
        ) {
            Icon(
                imageVector = Icons.Filled.Settings,
                contentDescription = "Settings",
                tint = MaterialTheme.colorScheme.onBackground,
            )
        }
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(32.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center,
        ) {
            Text(
                text = "Jelly Match",
                fontSize = 48.sp,
                fontWeight = FontWeight.Bold,
                color = MaterialTheme.colorScheme.onBackground,
            )
            Text(
                text = "✦ a herbalist's puzzle grimoire ✦",
                fontSize = 15.sp,
                fontWeight = FontWeight.Medium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            Spacer(Modifier.height(24.dp))
            LivesCounter(livesInfo)
            Spacer(Modifier.height(32.dp))
            Button(
                onClick = {
                    audioPlayer.playSfx(SoundEvent.UI_CLICK)
                    onNewGame()
                },
                modifier = Modifier.fillMaxWidth(0.6f),
            ) {
                Text("New Game", fontSize = 20.sp)
            }
            Spacer(Modifier.height(16.dp))
            Button(
                onClick = {
                    audioPlayer.playSfx(SoundEvent.UI_CLICK)
                    onJourney()
                },
                modifier = Modifier.fillMaxWidth(0.6f),
            ) {
                Text("Journey", fontSize = 20.sp)
            }
            Spacer(Modifier.height(16.dp))
            OutlinedButton(
                onClick = {
                    audioPlayer.playSfx(SoundEvent.UI_CLICK)
                    onFamiliars()
                },
                modifier = Modifier.fillMaxWidth(0.6f),
            ) {
                Text("Familiars", fontSize = 20.sp)
            }
            Spacer(Modifier.height(16.dp))
            OutlinedButton(
                onClick = {
                    audioPlayer.playSfx(SoundEvent.UI_CLICK)
                    onProfile()
                },
                modifier = Modifier.fillMaxWidth(0.6f),
            ) {
                Text("Profile", fontSize = 20.sp)
            }
            Spacer(Modifier.height(16.dp))
            OutlinedButton(
                onClick = {
                    audioPlayer.playSfx(SoundEvent.UI_CLICK)
                    onTestLevels()
                },
                modifier = Modifier.fillMaxWidth(0.6f),
            ) {
                Text("Test levels", fontSize = 20.sp)
            }
            if (hasContinueGame) {
                Spacer(Modifier.height(16.dp))
                OutlinedButton(
                    onClick = {
                        audioPlayer.playSfx(SoundEvent.UI_CLICK)
                        onContinue()
                    },
                    modifier = Modifier.fillMaxWidth(0.6f),
                ) {
                    Text("Continue", fontSize = 20.sp)
                }
            }
        }
        GemChip(
            balance = gemBalance,
            modifier = Modifier
                .align(Alignment.TopStart)
                .padding(16.dp),
        )
    }
}


@Composable
fun LivesCounter(livesInfo: LivesInfo) {
    val countdown = formatLivesCountdown(livesInfo.millisToNextLife)
    Text(
        text = if (livesInfo.current >= livesInfo.max) {
            "❤ ${livesInfo.current}/${livesInfo.max}"
        } else {
            "❤ ${livesInfo.current}/${livesInfo.max} • Next in $countdown"
        },
        fontSize = 16.sp,
        color = MaterialTheme.colorScheme.onSurfaceVariant,
    )
}

fun formatLivesCountdown(millis: Long): String {
    val totalSeconds = (millis.coerceAtLeast(0L) + 999L) / 1000L
    val minutes = totalSeconds / 60L
    val seconds = totalSeconds % 60L
    return "${minutes}:${seconds.toString().padStart(2, '0')}"
}
